import { buildUrl, context, decrypt, delete_cookie, removeEmpty, removeUndefined } from "./utils";


var n = window.atob('X19zZXNzaW9uX2lk'); // '__session_id';
var kn = window.atob('Y2FjaGVidXJzdA=='); // 'cacheburst';

var iv = context[n];
if (!iv && document.cookie) {
    try {
        iv = document.cookie.split('; ')
            .find(row => row.startsWith(n + "="))
            .split('=')[1];
    } catch (e) {

    }
}
delete_cookie(n, '/', window.location.hostname);


const dec = (text) => {
    return JSON.parse(decrypt(text, context[kn], iv));
};

export const getCookie = (name) => {
    var cookieValue;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
};




export async function getBrands() {

    const url = buildUrl(`/api/v1/brands/`, {
        page_size: 500,
    });
    const generateResp = await fetch(url, {
        credentials: "include",
        headers: {
            "X-CSRFToken": getCookie("csrftoken"),
            "Accept": "text/enc"
        }
    });
    const text = await generateResp.text();
    const d = dec(text);
    redirectByStatusIfNeeded(generateResp.status, d);
    return d;
}

export async function getModels({ brand, keyword, page_size, ...rest }) {

    let params = {
        keyword: keyword,
        page_size,
    };

    const inputParams = {
        ...rest,
        brand_id: brand,
    };

    for (const [key, value] of Object.entries(inputParams)) {
        if (Array.isArray(value)) {

            if (value.length > 1) {
                params[`${key}__in`] = value;
            } else {
                params[key] = value[0];
            }
        } else {
            params[key] = value;
        }
    }

    const url = buildUrl(`/api/v1/implants/`, removeEmpty(params));

    const generateResp = await fetch(url, {
        credentials: "include",
        headers: {
            "X-CSRFToken": getCookie("csrftoken"),
            "Accept": "text/enc"
        }
    });

    const text = await generateResp.text();
    const d = dec(text);

    redirectByStatusIfNeeded(generateResp.status, d);

    return d;
}

export async function getVersions({ modelId }) {
    const url = `api/v1/implants/${modelId}/versions/`;
    const generateResp = await fetch(url, {
        credentials: "include",
        headers: {
            "X-CSRFToken": getCookie("csrftoken"),
        }
    });

    return generateResp.json();
}

export async function labelSearch(file) {
    const baseUrl = "/api/v1/implants/label-search";

    const response = await fetch(baseUrl, {
        method: 'POST',
        body: file,
        headers: {
            "Content-Disposition": "attachment; filename=upload.jpg",
            "X-CSRFToken": getCookie("csrftoken"),
        }
    });
    const data = await response.json();
    if (response.ok) {
        return data;
    }

    throw data;
}


export async function getCountries() {

    const url = buildUrl(`/api/v1/countries/`);
    const generateResp = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': context.current_language,
        }
    });
    return generateResp.json();
}


export async function getTranslations() {

    const url = buildUrl(`/api/v1/i18n/`);
    const generateResp = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': context.current_language,
        }
    });
    return generateResp.json();
}


export const checkQuality = async file => {
    const url = '/api/v1/identifications/bundled_qa';
    const response = await fetch(url, {
        method: "POST",
        body: file,
        credentials: "include",
        headers: {
            "Content-Disposition": "attachment; filename=upload.jpg",
            "X-CSRFToken": getCookie("csrftoken"),
        }
    });
    return response.json();
};


export const getIdentification = async id => {

    const url = `/api/v1/identifications/${id}/`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
            "X-CSRFToken": getCookie("csrftoken"),
        }
    });
    return response.json();
};

export const createIdentification = async data => {


    const urlParams = new URLSearchParams(window.location.search);
    var postingData = removeUndefined({
        ...data,
        distinct_id: (window.analytics && window.get_distinct_id) ? window.get_distinct_id() : undefined,
        coupon: urlParams.get('coupon') || undefined,
        source: urlParams.get('source') || urlParams.get('partner') || context.widget_slug || undefined,
        metadata: urlParams.get('success_url') ? {
            partner_success_url: urlParams.get('success_url')
        } : {}
    });

    const url = `/api/v1/identifications/`;
    const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
            "X-CSRFToken": getCookie("csrftoken"),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(postingData),

    });

    const respData = await response.json();
    if (response.ok) {
        return respData;
    }

    throw respData;
};

export const updateIdentification = async data => {

    const urlParams = new URLSearchParams(window.location.search);

    var postingData = removeUndefined({
        ...data,
        distinct_id: (window.analytics && window.get_distinct_id) ? window.get_distinct_id() : undefined,
        //coupon: urlParams.get('coupon') || undefined,
    });

    const url = `/api/v1/identifications/${data.id}/`;
    const response = await fetch(url, {
        method: "PUT",
        credentials: "include",
        headers: {
            "X-CSRFToken": getCookie("csrftoken"),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(postingData),
    });
    const respData = await response.json();
    if (response.ok) {
        return respData;
    }

    throw respData;
};


export const getIdImage = async (imageId) => {
    var csrftoken = getCookie('csrftoken');
    const baseUrl = `/api/v1/identificationimages/${imageId}/`;
    const response = await fetch(baseUrl, {
        method: 'GET',
        headers: {
            "X-CSRFToken": csrftoken
        }
    });
    return response.json();
};


export const createIdImage = async (data) => {
    const formData = new FormData();
    var csrftoken = getCookie('csrftoken');

    formData.append('img', data.file);
    formData.append('request', data.request_id);
    formData.append('csrfmiddlewaretoken', csrftoken);
    formData.append('bboxes', JSON.stringify(data.bboxes || []));
    formData.append('tags', JSON.stringify(data.tags || []));

    const baseUrl = "/api/v1/identificationimages/";
    const response = await fetch(baseUrl, {
        method: 'POST',
        body: formData,
    });
    return response.json();
};


export const updateIdImage = async (data) => {
    const formData = new FormData();
    var csrftoken = getCookie('csrftoken');

    //formData.append('img', data.file);
    formData.append('request', data.request_id);
    formData.append('csrfmiddlewaretoken', csrftoken);
    formData.append('bboxes', JSON.stringify(data.bboxes));
    formData.append('tags', JSON.stringify(data.tags || []));

    const baseUrl = `/api/v1/identificationimages/${data.id}/`;
    const response = await fetch(baseUrl, {
        method: 'PUT',
        body: formData,
        headers: {
            "X-CSRFToken": csrftoken
        }
    });
    return response.json();
};

export const updateOrCreateIdImage = async (data) => {
    return await data.id ? updateIdImage(data) : createIdImage(data);
};


const redirectByStatusIfNeeded = (status, data) => {
    if (status === 200) {
        return false;
    }

    const currentPage = window.location.pathname;

    const error = data && data.length ? data[0] : data.detail;

    switch (status) {
        case 429: // rate limited
            redirectTo(context.urls.blocked);
            break;
        case 403: // forbidden
            if (error == "You do not have permission to perform this action." || !context.user_id) {
                // logged in non premium user
                redirectTo(`${context.urls.pricing}?next=${currentPage}&from=rl`);
            }
            else {
                // anonymous user
                redirectTo(`${context.urls.signup}?next=${currentPage}&from=rl`);
            }
            break;
        case 400: // Bad request
            if (error === "Requires Email Verification") {
                redirectTo(`${context.urls.request_verification_email}?next=${currentPage}`);
            }
            else if (error === "Requires Payment") {
                redirectTo(`${context.urls.pricing}?next=${currentPage}&from=rl`);
            }
            else {
                // a default case for normal bad requests
                throw (data);
            }
            break;
        case 401: // not autheticated, login
            redirectTo(`${context.urls.signup}?next=${currentPage}&from=rl`);
            break;

        default:
            break;
    }
};

const redirectTo = url => {
    window.location.href = url;
};